module.exports = __webpack_public_path__ + "static/img/hvu_quiz_icon.a16fd1f.svg";